// @ts-check
import { options } from "@/global/slick-options";
import { getAll } from "@/utilities/querySelector";

jQuery( function( $ ) {
    const sliders = getAll('[data-slider="auto-slider"]');
    if ( sliders.length ) {
        sliders.forEach( ( slider ) => {
            const direction = slider.getAttribute('data-slider-direction');

            $( slider ).slick( {
                ...options,
                arrows: false,
                autoplay: true,
                infinite: true,
                speed: 5000,
                autoplaySpeed: 0,
                slidesToScroll: 1,
                centerMode: true,
                pauseOnHover: false,
                rows: 1,
                cssEase: 'linear',
                rtl: direction === 'left' ? true : false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            } );
        });
    }
});
